import React from "react";
import Tickets from "../ReusedComponents/Tickets";
import { useParams } from "react-router-dom";

export default function MyTickets() {
  const { sid, uid } = useParams();
  return (
    <Tickets
      userType={"admin"}
      title={"Admin Dashboard"}
      options={[
        { title: "Create Ticket", url: `/tickets/admin/creating/${sid}/${uid}` },
        { title: "Reports", url: `/tickets/admin/reports/${sid}/${uid}` },
        { title: "Email Alerts", url: `/tickets/admin/email-alerts/${sid}/${uid}` },
      ]}
    />
  );
}
